function SecToHms (moment) {
  function filter (value) {
    return moment.utc(value * 1000).format('HH:mm:ss')
  }

  return {
    filter
  }
}

export default SecToHms
